import React from "react";
import Icon, { type IconType } from "./Icon";
import styles from "./Service.module.css";

interface ServiceProps {
  icon: IconType;
  title: string;
  children: React.ReactNode;
  features: string[];
}

const Service: React.FC<ServiceProps> = ({
  icon,
  title,
  features,
  children,
}) => {
  return (
    <div className={styles.service}>
      <Icon type={icon} />
      <h3>{title}</h3>
      <p>{children}</p>
      <ul className={styles.features}>
        {features.map((feature) => (
          <li key={feature}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

Service.displayName = "Service";

export default Service;
